/* Gestty — foto de la mascota en la ficha del retrato.
 * - Valida la foto (tipo y peso) y muestra una vista previa.
 * - Abre un editor de encuadre (arrastrar + zoom) con la proporción del tamaño elegido.
 * - Guarda en el formulario la foto YA recortada, para que el pedido lleve exactamente el encuadre del cliente.
 * - "2 mascotas" muestra el segundo campo de foto; el resto de opciones lo oculta y lo desactiva.
 */
(function () {
  'use strict';

  var MAX_BYTES = 10 * 1024 * 1024;
  var SALIDA_MAX = 2200;
  var TIPOS = /^image\/(jpeg|png|webp)$/;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  /* Eventos propios del embudo (solo existen si la persona aceptó las cookies y hay píxel en la página). */
  function evento(nombre) {
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', nombre, { content_name: 'Retrato personalizado de tu mascota' }); } catch (e) {}
  }

  /* Bloqueo del scroll con contador: varias ventanas pueden estar abiertas a la vez. */
  var bloqueos = 0;
  function bloquear(on) {
    bloqueos = Math.max(0, bloqueos + (on ? 1 : -1));
    document.documentElement.classList.toggle('gt-ed-abierto', bloqueos > 0);
  }

  /* ---------- tamaño elegido ---------- */
  function medidaActual(form) {
    var sel = $$('input[data-gt-opcion]:checked', form);
    for (var i = 0; i < sel.length; i++) {
      var m = /(\d+)\s*[×x]\s*(\d+)\s*cm/i.exec(sel[i].value);
      if (m) return { w: +m[1], h: +m[2], texto: m[1] + ' × ' + m[2] + ' cm' };
    }
    return { w: 30, h: 40, texto: '30 × 40 cm' };
  }
  function dosMascotas(form) {
    var sel = $$('input[data-gt-opcion]:checked', form);
    for (var i = 0; i < sel.length; i++) {
      if (/mascota/i.test(sel[i].value) && /^\s*(2|dos)\b/i.test(sel[i].value)) return true;
    }
    return false;
  }

  /* ---------- editor de encuadre (único en la página) ---------- */
  var ed = null;
  function crearEditor() {
    if (ed) return ed;
    var el = document.createElement('div');
    el.className = 'gt-ed';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Coloca tu foto');
    el.innerHTML =
      '<div class="gt-ed__panel">' +
      '<div class="gt-ed__cab"><h2>Coloca tu foto</h2><button type="button" class="gt-ed__x" aria-label="Cerrar">&times;</button></div>' +
      '<div class="gt-ed__cuerpo">' +
      '<p class="gt-ed__ayuda">Mueve la foto y acércala con <strong>+</strong>.</p>' +
      '<div class="gt-ed__escena">' +
      '<span class="gt-ed__medida"><strong data-ed-medida></strong></span>' +
      '<div class="gt-ed__marco" data-ed-marco><canvas tabindex="0" aria-label="Foto. Usa las flechas del teclado para moverla"></canvas><span class="gt-ed__rejilla" aria-hidden="true"></span></div>' +
      '</div>' +
      '<p class="gt-ed__pista" data-ed-pista hidden></p>' +
      '<div class="gt-ed__zoom"><button type="button" data-ed-menos aria-label="Alejar la foto">&minus;</button>' +
      '<input type="range" min="1" max="4" step="0.01" value="1" aria-label="Acercar o alejar la foto">' +
      '<button type="button" data-ed-mas aria-label="Acercar la foto">+</button></div>' +
      '<button type="button" class="gt-ed__centrar" data-ed-centrar>Centrar</button>' +
      '<p class="gt-ed__aviso" data-ed-aviso hidden></p>' +
      '</div>' +
      '<div class="gt-ed__pie"><button type="button" class="gt-btn gt-btn--ghost" data-ed-cancelar>Cancelar</button>' +
      '<button type="button" class="gt-btn" data-ed-aceptar>Usar esta foto</button></div>' +
      '</div>';
    document.body.appendChild(el);

    ed = {
      el: el,
      marco: $('[data-ed-marco]', el),
      canvas: $('canvas', el),
      rango: $('input[type=range]', el),
      aviso: $('[data-ed-aviso]', el),
      pista: $('[data-ed-pista]', el),
      medida: $('[data-ed-medida]', el),
      img: null, W: 0, H: 0, escala0: 1, zoom: 1, ox: 0, oy: 0,
      cb: null, medidaCm: null
    };

    function dibujar() {
      var c = ed.canvas, ctx = c.getContext('2d');
      var dpr = window.devicePixelRatio || 1;
      if (c.width !== Math.round(ed.W * dpr)) { c.width = Math.round(ed.W * dpr); c.height = Math.round(ed.H * dpr); }
      c.style.width = ed.W + 'px'; c.style.height = ed.H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.fillStyle = '#e9e5dc';
      ctx.fillRect(0, 0, ed.W, ed.H);
      if (!ed.img) return;
      var s = ed.escala0 * ed.zoom;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(ed.img, ed.ox, ed.oy, ed.img.naturalWidth * s, ed.img.naturalHeight * s);
    }
    function limitar() {
      var s = ed.escala0 * ed.zoom;
      var iw = ed.img.naturalWidth * s, ih = ed.img.naturalHeight * s;
      ed.ox = clamp(ed.ox, ed.W - iw, 0);
      ed.oy = clamp(ed.oy, ed.H - ih, 0);
    }
    function ponerZoom(z, px, py) {
      z = clamp(z, 1, 4);
      var sViejo = ed.escala0 * ed.zoom, sNuevo = ed.escala0 * z;
      if (px === undefined) { px = ed.W / 2; py = ed.H / 2; }
      var ix = (px - ed.ox) / sViejo, iy = (py - ed.oy) / sViejo;
      ed.zoom = z;
      ed.ox = px - ix * sNuevo; ed.oy = py - iy * sNuevo;
      ed.rango.value = z;
      limitar(); dibujar(); avisoResolucion();
    }
    function avisoResolucion() {
      var s = ed.escala0 * ed.zoom;
      var px = ed.W / s; // píxeles originales que cubren el ancho del marco
      var msg = '';
      if (px < 500) msg = 'Poca resolución: puede verse borrosa.';
      else if (px < 800) msg = 'Resolución justa para este tamaño.';
      ed.aviso.textContent = msg;
      ed.aviso.hidden = !msg;
    }
    function pista(img, medida) {
      var rf = medida.w / medida.h, ri = img.naturalWidth / img.naturalHeight, t = '';
      if (ri > rf * 1.15) t = 'Arrástrala hacia los lados.';
      else if (ri < rf / 1.15) t = 'Arrástrala hacia arriba o abajo.';
      ed.pista.textContent = t;
      ed.pista.hidden = !t;
    }
    ed.preparar = function (img, medida, estado, cb) {
      ed.img = img; ed.cb = cb; ed.medidaCm = medida;
      ed.medida.textContent = medida.texto;
      var maxW = Math.min(420, window.innerWidth - 48);
      var maxH = Math.max(170, Math.min(window.innerHeight - 470, 440));
      var W = maxW, H = W * medida.h / medida.w;
      if (H > maxH) { H = maxH; W = H * medida.w / medida.h; }
      ed.W = Math.round(W); ed.H = Math.round(H);
      ed.marco.style.width = ed.W + 'px'; ed.marco.style.height = ed.H + 'px';
      ed.escala0 = Math.max(ed.W / img.naturalWidth, ed.H / img.naturalHeight);
      ed.zoom = estado ? clamp(estado.zoom, 1, 4) : 1;
      var s = ed.escala0 * ed.zoom;
      var cx = estado ? estado.cx : 0.5, cy = estado ? estado.cy : 0.5;
      ed.ox = ed.W / 2 - cx * img.naturalWidth * s;
      ed.oy = ed.H / 2 - cy * img.naturalHeight * s;
      ed.rango.value = ed.zoom;
      pista(img, medida);
      limitar(); dibujar(); avisoResolucion();
    };
    ed.estado = function () {
      var s = ed.escala0 * ed.zoom;
      return { zoom: ed.zoom, cx: (ed.W / 2 - ed.ox) / s / ed.img.naturalWidth, cy: (ed.H / 2 - ed.oy) / s / ed.img.naturalHeight };
    };

    /* arrastrar con uno o dos dedos (pellizco = zoom) */
    var punteros = {};
    var arrastre = null, pellizco = null;
    function nPunteros() { return Object.keys(punteros).length; }
    ed.canvas.addEventListener('pointerdown', function (e) {
      punteros[e.pointerId] = { x: e.clientX, y: e.clientY };
      ed.canvas.setPointerCapture(e.pointerId);
      ed.marco.classList.add('gt-ed__marco--mueve');
      if (nPunteros() === 1) arrastre = { x: e.clientX, y: e.clientY, ox: ed.ox, oy: ed.oy };
      if (nPunteros() === 2) {
        var k = Object.keys(punteros), a = punteros[k[0]], b = punteros[k[1]];
        pellizco = { d: Math.hypot(a.x - b.x, a.y - b.y), z: ed.zoom };
        arrastre = null;
      }
    });
    ed.canvas.addEventListener('pointermove', function (e) {
      if (!punteros[e.pointerId]) return;
      punteros[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (nPunteros() === 2 && pellizco) {
        var k = Object.keys(punteros), a = punteros[k[0]], b = punteros[k[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y);
        if (pellizco.d > 10) ponerZoom(pellizco.z * d / pellizco.d);
        return;
      }
      if (!arrastre) return;
      ed.ox = arrastre.ox + (e.clientX - arrastre.x);
      ed.oy = arrastre.oy + (e.clientY - arrastre.y);
      limitar(); dibujar();
    });
    function suelta(e) {
      delete punteros[e.pointerId];
      pellizco = null;
      var q = Object.keys(punteros);
      if (q.length === 1) { var u = punteros[q[0]]; arrastre = { x: u.x, y: u.y, ox: ed.ox, oy: ed.oy }; }
      else arrastre = null;
      if (!q.length) ed.marco.classList.remove('gt-ed__marco--mueve');
    }
    ed.canvas.addEventListener('pointerup', suelta);
    ed.canvas.addEventListener('pointercancel', suelta);
    ed.canvas.addEventListener('wheel', function (e) {
      e.preventDefault();
      var r = ed.canvas.getBoundingClientRect();
      ponerZoom(ed.zoom * (e.deltaY < 0 ? 1.08 : 1 / 1.08), e.clientX - r.left, e.clientY - r.top);
    }, { passive: false });
    ed.canvas.addEventListener('keydown', function (e) {
      var paso = 12, hecho = true;
      if (e.key === 'ArrowLeft') ed.ox += paso;
      else if (e.key === 'ArrowRight') ed.ox -= paso;
      else if (e.key === 'ArrowUp') ed.oy += paso;
      else if (e.key === 'ArrowDown') ed.oy -= paso;
      else if (e.key === '+' || e.key === '=') { ponerZoom(ed.zoom + 0.1); return e.preventDefault(); }
      else if (e.key === '-') { ponerZoom(ed.zoom - 0.1); return e.preventDefault(); }
      else hecho = false;
      if (hecho) { e.preventDefault(); limitar(); dibujar(); }
    });
    ed.rango.addEventListener('input', function () { ponerZoom(parseFloat(ed.rango.value)); });
    $('[data-ed-menos]', el).addEventListener('click', function () { ponerZoom(ed.zoom - 0.25); });
    $('[data-ed-mas]', el).addEventListener('click', function () { ponerZoom(ed.zoom + 0.25); });
    $('[data-ed-centrar]', el).addEventListener('click', function () {
      ed.zoom = 1; ed.rango.value = 1;
      ed.ox = (ed.W - ed.img.naturalWidth * ed.escala0) / 2;
      ed.oy = (ed.H - ed.img.naturalHeight * ed.escala0) / 2;
      limitar(); dibujar(); avisoResolucion();
    });

    function cerrar(aceptar) {
      el.hidden = true;
      bloquear(false);
      document.documentElement.classList.remove('gt-editor-abierto');
      var cb = ed.cb; ed.cb = null;
      if (cb) cb(aceptar ? ed.estado() : null);
      if (ed.volverFoco && ed.volverFoco.focus) { try { ed.volverFoco.focus(); } catch (e) {} }
    }
    $('[data-ed-aceptar]', el).addEventListener('click', function () { cerrar(true); });
    $('[data-ed-cancelar]', el).addEventListener('click', function () { cerrar(false); });
    $('.gt-ed__x', el).addEventListener('click', function () { cerrar(false); });
    el.addEventListener('click', function (e) { if (e.target === el) cerrar(false); });
    document.addEventListener('keydown', function (e) { if (!el.hidden && e.key === 'Escape') cerrar(false); });

    ed.abrir = function (foco) {
      ed.volverFoco = foco;
      el.hidden = false;
      bloquear(true);
      document.documentElement.classList.add('gt-editor-abierto');
      try { $('[data-ed-aceptar]', el).focus({ preventScroll: true }); } catch (e) {}
      var pn = $('.gt-ed__panel', el); if (pn) pn.scrollTop = 0;
    };
    return ed;
  }

  /* ---------- recorte final a archivo ---------- */
  function recortar(img, medida, estado, nombre) {
    var ratio = medida.w / medida.h;
    var escala0Rel; // en unidades de la imagen original
    var iw = img.naturalWidth, ih = img.naturalHeight;
    // región visible a zoom 1: cubre el marco con la proporción dada
    var sw0 = Math.min(iw, ih * ratio), sh0 = sw0 / ratio;
    var sw = sw0 / estado.zoom, sh = sh0 / estado.zoom;
    var sx = clamp(estado.cx * iw - sw / 2, 0, iw - sw);
    var sy = clamp(estado.cy * ih - sh / 2, 0, ih - sh);
    var largo = Math.min(SALIDA_MAX, Math.max(sw, sh));
    var ow, oh;
    if (ratio >= 1) { ow = Math.round(largo); oh = Math.round(largo / ratio); }
    else { oh = Math.round(largo); ow = Math.round(largo * ratio); }
    var c = document.createElement('canvas');
    c.width = ow; c.height = oh;
    var ctx = c.getContext('2d');
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, sx, sy, sw, sh, 0, 0, ow, oh);
    return new Promise(function (ok) {
      c.toBlob(function (blob) {
        ok({ file: new File([blob], nombre, { type: 'image/jpeg' }), url: URL.createObjectURL(blob), px: Math.round(sw) });
      }, 'image/jpeg', 0.92);
    });
  }

  /* ---------- cada campo de foto ---------- */
  function iniciarCaja(caja, form) {
    var input = $('input[type=file]', caja);
    var zona = $('.gt-foto__zona', caja);
    var listo = $('.gt-foto__listo', caja);
    var miniatura = $('img', listo);
    var nombreEl = $('.gt-foto__nombre', caja);
    var infoEl = $('.gt-foto__info', caja);
    var error = $('.gt-foto__error', caja);
    var st = { orig: null, img: null, estado: null, url: null, nombre: '' };

    function fallo(msg) {
      input.value = '';
      st.orig = null; st.img = null;
      listo.hidden = true; zona.hidden = false;
      error.textContent = msg; error.hidden = false;
    }
    function cargar(file) {
      return new Promise(function (ok, ko) {
        var u = URL.createObjectURL(file);
        var im = new Image();
        im.onload = function () { URL.revokeObjectURL(u); ok(im); };
        im.onerror = function () { URL.revokeObjectURL(u); ko(); };
        im.src = u;
      });
    }
    var secuencia = 0;
    function aplicar() {
      if (!st.img) return Promise.resolve();
      var medida = medidaActual(form);
      var mio = ++secuencia;
      return recortar(st.img, medida, st.estado, st.nombre).then(function (r) {
        if (mio !== secuencia) { URL.revokeObjectURL(r.url); return; } /* llegó tarde: hay un recorte más nuevo */
        var dt = new DataTransfer();
        dt.items.add(r.file);
        input.files = dt.files;
        if (st.url) URL.revokeObjectURL(st.url);
        st.url = r.url;
        miniatura.src = r.url;
        miniatura.style.aspectRatio = medida.w + ' / ' + medida.h;
        nombreEl.textContent = st.orig ? st.orig.name : '';
        infoEl.textContent = 'Encuadre para ' + medida.texto;
        listo.hidden = false; zona.hidden = true;
        form.dispatchEvent(new CustomEvent('gt:foto', { bubbles: true }));
      });
    }
    function abrirEditor() {
      var e = crearEditor();
      e.preparar(st.img, medidaActual(form), st.estado, function (estado) {
        if (estado) { st.estado = estado; aplicar(); }
      });
      e.abrir($('.gt-foto__ajustar', caja));
    }

    input.addEventListener('change', function () {
      error.hidden = true;
      var f = input.files && input.files[0];
      if (!f) return;
      if (f === (st.lastCropped || null)) return;
      if (!TIPOS.test(f.type)) return fallo('Esa foto no es JPG, PNG ni WebP. Si es de iPhone, vuelve a elegirla desde la galería.');
      if (f.size > MAX_BYTES) return fallo('La foto pesa más de 10 MB. Elige otra o reduce su tamaño.');
      cargar(f).then(function (im) {
        st.orig = f; st.img = im; st.nombre = f.name.replace(/\.[^.]+$/, '') + '-encuadre.jpg';
        st.estado = { zoom: 1, cx: 0.5, cy: 0.5 };
        return aplicar().then(function () {
          var e = crearEditor();
          e.preparar(st.img, medidaActual(form), st.estado, function (estado) {
            if (estado) { st.estado = estado; aplicar(); }
          });
          e.abrir($('.gt-foto__ajustar', caja));
        });
      }, function () { fallo('No hemos podido abrir esa foto. Prueba con otra en JPG o PNG.'); });
    });

    $('.gt-foto__ajustar', caja).addEventListener('click', abrirEditor);
    $('.gt-foto__cambiar', caja).addEventListener('click', function () { input.value = ''; input.click(); });

    /* si cambia el tamaño, se recorta de nuevo con la nueva proporción */
    form.addEventListener('change', function (e) {
      if (!st.img || !e.target.matches('input[data-gt-opcion]')) return;
      aplicar();
    });
  }

  /* ---------- vista previa del retrato (IA): ventana con versiones por estilo ---------- */
  function iniciarGenerador(gen, conj, form) {
    var url = '';
    try { url = window.localStorage.getItem('gtGeneradorUrl') || ''; } catch (e) { url = ''; }
    url = url || gen.getAttribute('data-url') || '';
    if (!url) { gen.hidden = true; conj.setAttribute('data-gen', 'no'); return; }

    /* La ventana vive fuera del formulario; su archivo «Retrato» se asocia al formulario por id. */
    /* OJO: form.id devuelve el campo <input name="id"> (variante), no el atributo: se usa getAttribute. */
    var formId = form.getAttribute('id');
    if (!formId) { formId = 'gt-form-producto'; form.setAttribute('id', formId); }
    document.body.appendChild(gen);
    var base = url.replace(/\/preview\/?$/, '');

    var NOM = { acuarela: 'acuarela', oleo: 'óleo clásico' };
    var MSG = {
      acuarela: ['Preparando tu foto…', 'Mezclando las acuarelas…', 'Dibujando su mirada…', 'Dando color al pelaje…', 'Últimos toques…'],
      oleo: ['Preparando tu foto…', 'Preparando los óleos…', 'Dibujando su mirada…', 'Dando textura al pelaje…', 'Últimos toques…']
    };
    var q = function (s) { return $(s, gen); };
    var titulo = q('[data-gt-gen-titulo]'), sub = q('[data-gt-gen-sub]');
    var marco = q('[data-gt-gen-marco]'), imgRet = q('[data-gt-gen-img]'), imgFoto = q('[data-gt-gen-foto]');
    var carga = q('[data-gt-gen-carga]'), msg = q('[data-gt-gen-msg]'), prog = q('[data-gt-gen-prog]');
    var tabsWrap = q('[data-gt-gen-tabs]'), tabs = $$('[data-gt-gen-tab]', gen);
    var versWrap = q('[data-gt-gen-versiones]'), bComparar = q('[data-gt-gen-comparar]'), notaRest = q('[data-gt-gen-restantes]');
    var bUsar = q('[data-gt-gen-usar]'), bOtra = q('[data-gt-gen-otra]');
    var bSeguir = q('[data-gt-gen-seguir]'), bCambiar = q('[data-gt-gen-cambiar]');
    var bSaltar = q('[data-gt-gen-saltar]'), bCerrar = q('[data-gt-gen-cerrar]');
    var err = q('[data-gt-gen-error]');
    var inputRetrato = $('input[name="properties[Retrato]"]', gen);
    inputRetrato.setAttribute('form', formId);

    var st = {
      estado: 'reposo',            /* reposo | cargando | resultado | error */
      vers: { acuarela: [], oleo: [] },
      idx: { acuarela: 0, oleo: 0 },
      tab: 'acuarela', generando: null,
      base: '', codigo: '', avisoError: '',
      disponible: true, restantes: null,
      aborto: null, timer: null, prog: null, pasar: false,
      aprobado: false, elegida: null, revelar: false, verFoto: false, fotoFallida: 1, primera: true
    };

    function ping() {
      var ctl = new AbortController();
      var t = setTimeout(function () { ctl.abort(); }, 4000);
      return fetch(base + '/salud', { signal: ctl.signal, cache: 'no-store' })
        .then(function (r) { clearTimeout(t); return r.json(); })
        .then(function (d) { return !!(d && d.ok && d.activo !== false); })
        .catch(function () { clearTimeout(t); return false; });
    }
    function fotos() {
      var out = [$('input[name="properties[Foto]"]', conj)];
      if (dosMascotas(form)) out.push($('input[name="properties[Foto 2]"]', conj));
      return out;
    }
    function estiloForm() {
      var r = $('input[name="properties[Estilo]"]:checked', form);
      return r && /acuarela/i.test(r.value) ? 'acuarela' : 'oleo';
    }
    function ponerEstiloForm(e) {
      var r = $$('input[name="properties[Estilo]"]', form).filter(function (i) { return /acuarela/i.test(i.value) === (e === 'acuarela'); })[0];
      if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    function detalles() { var t = $('textarea[name="properties[Detalles]"]', form); return t ? t.value.trim() : ''; }
    /* La huella NO incluye el estilo: cada estilo guarda su versión para la misma foto y los mismos detalles. */
    function huella() {
      return fotos().map(function (i) { var a = i.files && i.files[0]; return a ? a.name + ':' + a.size + ':' + a.lastModified : '-'; }).join('|') + '|' + detalles();
    }
    function listoParaCrear() { return fotos().every(function (i) { return i && i.files && i.files[0]; }); }
    function hayVersiones() { return st.vers.acuarela.length + st.vers.oleo.length > 0; }
    function vistaActual() { var a = st.vers[st.tab]; return a && a.length ? a[st.idx[st.tab]] : null; }
    function foto1Src() { var i = $('[data-gt-foto] .gt-foto__listo img', conj); return i ? (i.getAttribute('src') || '') : ''; }

    function olvidarVersiones() {
      ['acuarela', 'oleo'].forEach(function (e) { st.vers[e].forEach(function (v) { try { URL.revokeObjectURL(v.url); } catch (x) {} }); st.vers[e] = []; st.idx[e] = 0; });
      st.aprobado = false; st.elegida = null; st.base = ''; st.verFoto = false; st.avisoError = '';
      window.gtRetratoActual = null;
    }

    function abrir() {
      gen.hidden = false;
      bloquear(true);
      var m = medidaActual(form);
      marco.style.aspectRatio = m.w + ' / ' + m.h;
      marco.style.setProperty('--gt-r', (m.w / m.h).toFixed(4));
      var p = $('.gt-gen__panel', gen); if (p) p.scrollTop = 0;
    }
    function detener() {
      if (st.aborto) { try { st.aborto.abort(); } catch (e) {} }
      clearInterval(st.timer); clearInterval(st.prog);
      st.aborto = null;
    }
    function cerrar() {
      if (st.estado === 'cargando') { detener(); st.estado = hayVersiones() ? 'resultado' : 'reposo'; }
      gen.hidden = true;
      bloquear(false);
    }
    function ocultarTodo() { [bUsar, bOtra, bSeguir, bCambiar, bComparar, versWrap, notaRest].forEach(function (b) { b.hidden = true; }); }

    function pintarTabs() {
      var sel = st.estado === 'cargando' ? st.generando : st.tab;
      var sinIntentos = st.restantes !== null && st.restantes <= 0;
      tabs.forEach(function (t) {
        var e = t.getAttribute('data-gt-gen-tab');
        var n = st.vers[e].length;
        var estado = $('[data-gt-gen-tab-estado]', t);
        t.setAttribute('aria-selected', e === sel ? 'true' : 'false');
        t.classList.toggle('gt-gen__tab--hecho', n > 0);
        t.disabled = st.estado === 'cargando' || (n === 0 && sinIntentos);
        if (st.estado === 'cargando' && e === st.generando) estado.textContent = 'creando…';
        else if (n > 0) estado.textContent = n > 1 ? n + ' versiones' : 'listo';
        else estado.textContent = sinIntentos ? 'sin pruebas' : 'crear';
      });
    }
    function pintarVersiones() {
      var lista = st.vers[st.tab];
      versWrap.innerHTML = '';
      if (lista.length < 2) { versWrap.hidden = true; return; }
      lista.forEach(function (v, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'gt-gen__ver';
        b.setAttribute('aria-label', 'Ver la versión ' + (i + 1) + ' en ' + NOM[st.tab]);
        b.setAttribute('aria-current', i === st.idx[st.tab] ? 'true' : 'false');
        var im = document.createElement('img'); im.src = v.url; im.alt = ''; b.appendChild(im);
        b.addEventListener('click', function () {
          st.idx[st.tab] = i; st.revelar = false; st.verFoto = false;
          window.gtRetratoActual = v.url; window.gtFijarPrincipal(form);
          pintar();
        });
        versWrap.appendChild(b);
      });
      versWrap.hidden = false;
    }

    function pintar() {
      ocultarTodo();
      err.hidden = true;
      var m = medidaActual(form);
      marco.style.aspectRatio = m.w + ' / ' + m.h;
      marco.style.setProperty('--gt-r', (m.w / m.h).toFixed(4));
      var fsrc = foto1Src();
      if (fsrc && imgFoto.getAttribute('src') !== fsrc) imgFoto.src = fsrc;
      marco.classList.toggle('gt-gen--cargando', st.estado === 'cargando');
      marco.classList.toggle('gt-gen--ver-foto', st.verFoto && st.estado === 'resultado');
      tabsWrap.hidden = st.estado === 'error' || st.estado === 'reposo';
      pintarTabs();

      if (st.estado === 'cargando') {
        titulo.textContent = 'Estamos pintando a tu mascota';
        sub.textContent = 'En ' + NOM[st.generando] + ' · unos 20 segundos. No cierres esta ventana.';
        marco.hidden = false; carga.hidden = false;
        imgRet.removeAttribute('src');
        bSaltar.hidden = false; bSaltar.textContent = hayVersiones() ? 'Cancelar y volver' : 'Continuar sin esperar';
      } else if (st.estado === 'resultado') {
        var ver = vistaActual();
        marco.hidden = false; carga.hidden = true;
        if (ver && imgRet.getAttribute('src') !== ver.url) imgRet.src = ver.url;
        if (st.revelar) {
          imgRet.classList.remove('gt-gen--revela'); void imgRet.offsetWidth; imgRet.classList.add('gt-gen--revela');
          st.revelar = false;
        }
        titulo.textContent = st.primera ? '¡Mira qué carita!' : 'Así queda en ' + NOM[st.tab];
        sub.textContent = 'En ' + NOM[st.tab] + ' · creado con IA a partir de tu foto. Aún no has pagado nada.';
        bUsar.hidden = false;
        var sinIntentos = st.restantes !== null && st.restantes <= 0;
        bOtra.hidden = sinIntentos;
        bOtra.textContent = 'Probar otra versión en ' + NOM[st.tab];
        var otra = st.tab === 'acuarela' ? 'oleo' : 'acuarela';
        if (!sinIntentos && st.vers[otra].length === 0) {
          /* pista para descubrir el otro estilo */
          notaRest.textContent = '¿Y en ' + NOM[otra] + '? Pulsa su pestaña para verlo.';
          notaRest.hidden = false;
        }
        if (st.restantes !== null) {
          notaRest.textContent = sinIntentos
            ? 'Has usado tus pruebas de hoy. Puedes continuar con las que ya tienes.'
            : 'Te quedan ' + st.restantes + (st.restantes === 1 ? ' prueba' : ' pruebas') + ' hoy.';
          notaRest.hidden = false;
        }
        bComparar.hidden = !fsrc || dosMascotas(form);
        bComparar.textContent = st.verFoto ? 'Ver mi retrato' : 'Comparar con mi foto';
        pintarVersiones();
        bSaltar.hidden = false; bSaltar.textContent = 'Continuar sin usar esta vista previa';
        if (st.avisoError) { err.textContent = st.avisoError; err.hidden = false; }
      } else if (st.estado === 'error') {
        titulo.textContent = st.codigo === 'no_mascota' ? 'No vemos a tu mascota en la foto' : 'No hemos podido crear la vista previa';
        sub.textContent = '';
        marco.hidden = true; carga.hidden = true;
        err.hidden = !err.textContent;
        if (st.codigo === 'no_mascota') { bCambiar.hidden = false; bSaltar.hidden = false; bSaltar.textContent = 'Continuar de todas formas'; }
        else { bSeguir.hidden = false; bSaltar.hidden = true; }
      }
    }
    function error(codigo, texto) { st.estado = 'error'; st.codigo = codigo || ''; err.textContent = texto || ''; pintar(); }

    function iniciarProgreso(estilo) {
      var p = 4, i = 0;
      prog.style.width = p + '%';
      var lista = MSG[estilo] || MSG.acuarela;
      msg.textContent = lista[0];
      clearInterval(st.prog); clearInterval(st.timer);
      st.prog = setInterval(function () { p += (93 - p) * 0.055; prog.style.width = p.toFixed(1) + '%'; }, 450);
      st.timer = setInterval(function () { i = Math.min(i + 1, lista.length - 1); msg.textContent = lista[i]; }, 5000);
    }

    /* Crea una versión nueva en ese estilo; si ya hay una y no se fuerza, solo la muestra. */
    function crear(estilo, forzar) {
      if (st.estado === 'cargando') return;
      if (hayVersiones() && st.base && st.base !== huella()) olvidarVersiones();
      if (st.vers[estilo].length && !forzar) { mostrarEstilo(estilo); return; }
      st.generando = estilo; st.estado = 'cargando'; st.avisoError = ''; st.verFoto = false;
      pintar();
      msg.textContent = 'Comprobando la conexión…';
      var baseAlCrear = huella();
      ping().then(function (vivo) {
        if (st.estado !== 'cargando') return;
        if (!vivo) {
          st.disponible = false; detener();
          if (hayVersiones()) { st.estado = 'resultado'; st.avisoError = 'Ahora mismo no podemos crear más versiones. Puedes continuar con las que ya tienes.'; return pintar(); }
          return continuar(false);
        }
        iniciarProgreso(estilo);
        var fd = new FormData();
        var fs = fotos();
        fd.append('foto', fs[0].files[0]);
        if (fs[1]) fd.append('foto2', fs[1].files[0]);
        fd.append('estilo', estilo);
        fd.append('detalles', detalles());
        st.aborto = new AbortController();
        var corte = setTimeout(function () { if (st.aborto) st.aborto.abort(); }, 100000);
        function falla(codigo, texto) {
          clearTimeout(corte); detener();
          if (st.estado !== 'cargando') return;
          if (hayVersiones()) { st.estado = 'resultado'; st.avisoError = texto; return pintar(); }
          error(codigo, texto);
        }
        fetch(url, { method: 'POST', body: fd, signal: st.aborto.signal })
          .then(function (r) { return r.json().catch(function () { return { ok: false, error: 'respuesta' }; }); })
          .then(function (d) {
            if (st.estado !== 'cargando') return;
            if (!d.ok) {
              if (/limite|desactivado|openai_red|respuesta|origen/.test(d.error || '')) st.disponible = false;
              if (d.error === 'limite') st.restantes = 0;
              st.fotoFallida = d.foto || 1;
              return falla(d.error === 'no_mascota' ? 'no_mascota' : 'otro',
                d.mensaje || 'Puedes seguir con tu pedido igualmente: te enviaremos la prueba por email y no imprimiremos nada hasta que la apruebes.');
            }
            clearTimeout(corte); detener();
            prog.style.width = '100%';
            var bin = atob(d.imagen), n = bin.length, u8 = new Uint8Array(n);
            while (n--) u8[n] = bin.charCodeAt(n);
            var blob = new Blob([u8], { type: 'image/png' });
            var ver = { blob: blob, url: URL.createObjectURL(blob), estilo: estilo };
            if (hayVersiones() && st.base && st.base !== baseAlCrear) olvidarVersiones();
            st.vers[estilo].push(ver);
            st.idx[estilo] = st.vers[estilo].length - 1;
            st.tab = estilo; st.base = baseAlCrear;
            st.restantes = typeof d.restantes === 'number' ? d.restantes : st.restantes;
            st.estado = 'resultado'; st.revelar = true; st.aprobado = false; st.elegida = null;
            window.gtRetratoActual = ver.url;
            ponerEstiloForm(estilo);
            window.gtFijarPrincipal(form);
            evento('VistaPreviaCreada');
            pintar();
            st.primera = false;
          })
          .catch(function () {
            falla('otro', 'Se ha agotado el tiempo. Puedes seguir con tu pedido igualmente: te enviaremos la prueba por email.');
          });
      });
    }

    function mostrarEstilo(estilo) {
      st.tab = estilo; st.estado = 'resultado'; st.revelar = false; st.verFoto = false; st.avisoError = '';
      var v = vistaActual();
      if (v) { window.gtRetratoActual = v.url; ponerEstiloForm(estilo); window.gtFijarPrincipal(form); }
      pintar();
    }

    function enviarPedido() {
      var ver = st.elegida;
      var hecho = function () { st.pasar = true; cerrar(); if (conj._cerrar) conj._cerrar(); form.submit(); };
      if (!ver || !ver.url) { inputRetrato.disabled = true; return hecho(); }
      var tmp = new Image();
      tmp.onload = function () {
        var c = document.createElement('canvas');
        c.width = tmp.naturalWidth; c.height = tmp.naturalHeight;
        c.getContext('2d').drawImage(tmp, 0, 0);
        c.toBlob(function (b) {
          var dt = new DataTransfer();
          dt.items.add(new File([b], 'retrato-aprobado.jpg', { type: 'image/jpeg' }));
          inputRetrato.files = dt.files;
          inputRetrato.disabled = false;
          hecho();
        }, 'image/jpeg', 0.93);
      };
      tmp.onerror = function () { inputRetrato.disabled = true; hecho(); };
      tmp.src = ver.url;
    }

    /* Tras la vista previa, el cliente sigue al último paso del asistente (extras y cantidad); el pedido se envía allí. */
    function continuar(conRetrato) {
      var ver = conRetrato ? vistaActual() : null;
      st.aprobado = !!ver; st.elegida = ver;
      if (ver) { window.gtRetratoActual = ver.url; ponerEstiloForm(st.tab); window.gtFijarPrincipal(form); evento('VistaPreviaAprobada'); }
      if (st.estado === 'cargando') { detener(); st.estado = hayVersiones() ? 'resultado' : 'reposo'; }
      gen.hidden = true; bloquear(false);
      if (conj._ir) conj._ir(2);
    }

    bUsar.addEventListener('click', function () { continuar(true); });
    bSeguir.addEventListener('click', function () { continuar(false); });
    bSaltar.addEventListener('click', function () {
      if (st.estado === 'cargando' && hayVersiones()) { detener(); st.estado = 'resultado'; return pintar(); }
      continuar(false);
    });
    bOtra.addEventListener('click', function () { crear(st.tab, true); });
    bComparar.addEventListener('click', function () { st.verFoto = !st.verFoto; pintar(); });
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var e = t.getAttribute('data-gt-gen-tab');
        if (st.estado === 'cargando') return;
        if (st.vers[e].length) return mostrarEstilo(e);
        if (st.restantes !== null && st.restantes <= 0) return;
        crear(e, false);
      });
    });
    bCambiar.addEventListener('click', function () {
      /* Directo al selector de archivos de la foto que ha fallado, sin pasar por pasos intermedios. */
      cerrar();
      if (conj._ir) conj._ir(1);
      var inp = $('input[name="' + (st.fotoFallida === 2 ? 'properties[Foto 2]' : 'properties[Foto]') + '"]', conj);
      if (inp) { inp.value = ''; inp.click(); }
    });
    bCerrar.addEventListener('click', cerrar);
    gen.addEventListener('click', function (e) { if (e.target === gen) cerrar(); });
    document.addEventListener('keydown', function (e) { if (!gen.hidden && e.key === 'Escape') cerrar(); });

    /* Si cambia la foto o los detalles, las versiones ya creadas dejan de valer (el estilo NO las invalida). */
    ['change', 'input', 'gt:foto'].forEach(function (ev) {
      form.addEventListener(ev, function () {
        setTimeout(function () {
          if (st.estado === 'cargando') return;
          if ((hayVersiones() || st.estado === 'error') && st.base !== huella()) {
            olvidarVersiones();
            st.estado = 'reposo'; st.primera = true;
            window.gtFijarPrincipal(form);
          }
        }, 0);
      });
    });

    /* Al añadir al carrito: si el cliente aprobó su vista previa, el archivo «Retrato» viaja en el pedido. */
    form.addEventListener('submit', function (e) {
      if (st.pasar) { st.pasar = false; return; }
      if (st.aprobado && st.elegida && st.base === huella()) {
        e.preventDefault(); e.stopImmediatePropagation();
        enviarPedido();
      }
    }, true);

    /* «Ver mi retrato» (paso 1 del asistente): abre la ventana; si ya hay versiones de esta foto, las muestra al instante. */
    conj._previa = function () {
      if (!st.disponible || !listoParaCrear()) { if (conj._ir) conj._ir(2); return; }
      abrir();
      if (hayVersiones() && st.base === huella()) {
        var e = vistaActual() ? st.tab : (st.vers.acuarela.length ? 'acuarela' : 'oleo');
        mostrarEstilo(e);
      } else {
        olvidarVersiones();
        st.primera = true;
        crear(estiloForm(), true);
      }
    };

    conj.setAttribute('data-gen', 'si');
    ping().then(function (vivo) {
      if (!vivo) { st.disponible = false; conj.setAttribute('data-gen', 'no'); }
    });
  }

  /* ---------- asistente paso a paso (ventana que se abre con «Personalizar mi retrato») ---------- */
  function iniciarAsistente(form, wiz) {
    var root = form.closest('[data-gt-producto]') || document;
    var abrirBtn = $('[data-gt-wiz-abrir]', form);
    var pasos = $$('[data-gt-wiz-n]', wiz);
    var total = pasos.length;
    var actual = 1;
    var lblPaso = $('[data-gt-wiz-paso]', wiz), barra = $('[data-gt-wiz-progreso]', wiz);
    var bAtras = $('[data-gt-wiz-atras]', wiz), bSig = $('[data-gt-wiz-siguiente]', wiz), bFin = $('[data-gt-wiz-enviar]', wiz);
    var bCerrar = $('[data-gt-wiz-cerrar]', wiz), err = $('[data-gt-wiz-error]', wiz), totalEl = $('[data-gt-wiz-total]', wiz);
    var cuerpo = $('.gt-wiz__cuerpo', wiz);
    var NOMBRES = ['Tu foto', 'Último paso'];
    var variantes = [];
    try { variantes = JSON.parse($('[data-gt-variantes]', root).textContent); } catch (e) { variantes = []; }

    /* «+ 9,99 €»: diferencia de precio de cada opción respecto a la primera, con las demás opciones como estén ahora */
    function dinero(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
    function pintarExtras() {
      var marcadas = {};
      $$('input[data-gt-opcion]:checked', form).forEach(function (i) { marcadas[i.getAttribute('data-gt-opcion')] = i.value; });
      function precioCon(op, valor) {
        var q = {};
        for (var k in marcadas) q[k] = marcadas[k];
        q[op] = valor;
        var v = variantes.find(function (x) {
          return [1, 2, 3].every(function (n) { return !q[n] || x['option' + n] === q[n]; });
        });
        return v ? v.price : null;
      }
      $$('input[data-gt-opcion]', wiz).forEach(function (inp) {
        var op = inp.getAttribute('data-gt-opcion');
        if (op === '1') return;
        var primero = $$('input[data-gt-opcion="' + op + '"]', wiz)[0];
        if (!primero || primero === inp) return;
        var a = precioCon(op, inp.value), b = precioCon(op, primero.value);
        var label = inp.nextElementSibling;
        if (!label) return;
        var etq = $('.gt-extra', label);
        if (a === null || b === null || a <= b) { if (etq) etq.remove(); return; }
        if (!etq) { etq = document.createElement('small'); etq.className = 'gt-extra'; label.appendChild(etq); }
        etq.textContent = '+ ' + dinero(a - b);
      });
    }

    /* Resumen del pedido (paso 4) */
    var resumen = document.createElement('div');
    resumen.className = 'gt-wiz__resumen';
    var paso4 = pasos[total - 1];
    if (paso4) paso4.insertBefore(resumen, paso4.children[2] || null);
    function pintarResumen() {
      var m = medidaActual(form);
      var e = $('input[name="properties[Estilo]"]:checked', form);
      var f = $('.gt-foto__listo img', wiz);
      var partes = [m.texto, dosMascotas(form) ? '2 mascotas' : '1 mascota', e ? e.value : ''].filter(Boolean);
      resumen.innerHTML = '';
      var srcImg = window.gtRetratoActual || (f && f.getAttribute('src')) || '';
      if (srcImg) {
        var im = document.createElement('img');
        im.src = srcImg; im.alt = window.gtRetratoActual ? 'Tu retrato' : 'Tu foto';
        resumen.appendChild(im);
      }
      var t = document.createElement('div');
      t.innerHTML = '<strong>Tu pedido</strong><span></span>';
      t.lastChild.textContent = partes.join(' · ');
      resumen.appendChild(t);
    }

    function precio() {
      var e = $('[data-gt-barra-precio]', root) || $('[data-gt-precio]', root);
      return e ? e.textContent.trim() : '';
    }
    function fotosListas() {
      var f = [$('input[name="properties[Foto]"]', wiz)];
      if (dosMascotas(form)) f.push($('input[name="properties[Foto 2]"]', wiz));
      return f.every(function (i) { return i && i.files && i.files[0]; });
    }
    function mensaje(t) { err.textContent = t || ''; err.hidden = !t; }
    function mostrar(n) {
      actual = Math.max(1, Math.min(total, n));
      pasos.forEach(function (p, k) { p.hidden = (k + 1) !== actual; });
      lblPaso.textContent = 'Paso ' + actual + ' de ' + total + ' · ' + (NOMBRES[actual - 1] || '');
      barra.style.width = (actual / total * 100) + '%';
      bAtras.hidden = actual === 1;
      bSig.hidden = actual === total;
      bFin.hidden = actual !== total;
      bFin.textContent = 'Añadir al carrito';
      bSig.textContent = wiz.getAttribute('data-gen') === 'si' ? 'Ver mi retrato' : 'Siguiente';
      totalEl.textContent = precio();
      mensaje('');
      if (cuerpo) cuerpo.scrollTop = 0;
      pintarExtras();
      if (actual === total) pintarResumen();
      var h = $('h2', pasos[actual - 1]);
      if (h) { h.setAttribute('tabindex', '-1'); try { h.focus({ preventScroll: true }); } catch (e) {} }
    }
    var avisado = false;
    function abrir() {
      wiz.hidden = false;
      bloquear(true);
      mostrar(actual);
      /* Evento estándar de Meta «Personalizar producto» (solo existe si la persona aceptó las cookies). */
      if (!avisado && typeof window.fbq === 'function') {
        avisado = true;
        try { window.fbq('track', 'CustomizeProduct', { content_name: 'Retrato personalizado de tu mascota', content_type: 'product' }); } catch (e) {}
      }
    }
    function cerrar() {
      wiz.hidden = true;
      bloquear(false);
    }
    function validar(n) {
      if (n === 1 && !fotosListas()) {
        mensaje(dosMascotas(form) ? 'Sube la foto de cada mascota.' : 'Sube la foto de tu mascota.');
        return false;
      }
      return true;
    }

    if (abrirBtn) abrirBtn.addEventListener('click', function () { if (!abrirBtn.disabled) abrir(); });
    bSig.addEventListener('click', function () {
      if (!validar(actual)) return;
      if (actual === 1) {
        evento('FotoSubida');
        if (wiz.getAttribute('data-gen') === 'si' && typeof wiz._previa === 'function') { wiz._previa(); return; }
      }
      mostrar(actual + 1);
    });
    bAtras.addEventListener('click', function () { mostrar(actual - 1); });
    bCerrar.addEventListener('click', cerrar);
    wiz.addEventListener('click', function (e) { if (e.target === wiz) cerrar(); });
    document.addEventListener('keydown', function (e) {
      var ed = document.querySelector('.gt-ed');
      var gen = document.querySelector('[data-gt-gen]');
      if (e.key === 'Escape' && !wiz.hidden && (!ed || ed.hidden) && (!gen || gen.hidden)) cerrar();
    });
    ['change', 'gt:foto'].forEach(function (ev) {
      form.addEventListener(ev, function () {
        setTimeout(function () { if (!wiz.hidden) { totalEl.textContent = precio(); mensaje(''); pintarExtras(); if (actual === total) pintarResumen(); } }, 30);
      });
    });
    /* Al enviar: se comprueba todo antes de seguir (el formulario va sin validación del navegador). */
    form.addEventListener('submit', function (e) {
      if (!fotosListas()) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (wiz.hidden) abrir();
        mostrar(1); mensaje(dosMascotas(form) ? 'Sube la foto de cada mascota para continuar.' : 'Sube la foto de tu mascota para continuar.');
      }
    }, true);
    /* La ventana de vista previa cierra el asistente al continuar con el pedido */
    wiz._cerrar = cerrar;
    wiz._ir = function (n) { if (wiz.hidden) abrir(); mostrar(n); };
  }

  /* ---------- foto principal: una imagen fija por combinación de opciones ---------- */
  var COMBOS = null;
  function cargarCombos(raiz) {
    if (COMBOS !== null) return COMBOS;
    var el = $('[data-gt-combos]', raiz || document);
    try { COMBOS = el ? JSON.parse(el.textContent) : {}; } catch (e) { COMBOS = {}; }
    return COMBOS;
  }
  function claveCombo(form) {
    var m = medidaActual(form);
    var tam = m.w + 'x' + m.h;
    var mas = dosMascotas(form) ? '2' : '1';
    var dig = 'poster';
    $$('input[data-gt-opcion]:checked', form).forEach(function (i) { if (/y\s+archivo|digital/i.test(i.value) && !/^solo/i.test(i.value)) dig = 'dig'; });
    var e = $('input[name="properties[Estilo]"]:checked', form);
    var est = e && /óleo|oleo/i.test(e.value) ? 'oleo' : 'acuarela';
    return tam + '|' + mas + '|' + dig + '|' + est;
  }
  window.gtFijarPrincipal = function (form, forzarCombo) {
    var raiz = form.closest('[data-gt-producto]') || document;
    var principal = $('[data-gt-principal]', raiz);
    if (!principal) return;
    /* Si el cliente ya ha generado su retrato, ese es el que se ve (es SU producto) */
    var gen = window.gtRetratoActual;
    var src = (!forzarCombo && gen) ? gen : cargarCombos(raiz)[claveCombo(form)];
    if (!src) return;
    if (principal.getAttribute('src') !== src) { principal.src = src; principal.srcset = ''; }
    var etq = $('[data-gt-etiqueta]', raiz);
    if (etq) { etq.hidden = true; }
  };

  function iniciar() {
    $$('[data-gt-foto-conj]').forEach(function (conj) {
      var form = conj.closest('form');
      if (!form) return;
      $$('[data-gt-foto]', conj).forEach(function (caja) { iniciarCaja(caja, form); });

      if (conj.hasAttribute('data-gt-wiz')) iniciarAsistente(form, conj);
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[data-gt-opcion], input[name="properties[Estilo]"]')) {
          window.gtFijarPrincipal(form);
        }
      });

      var gen = $('[data-gt-gen]', conj);
      if (gen) iniciarGenerador(gen, conj, form);

      var segunda = $('[data-gt-foto-2]', conj);
      var primera = $('[data-gt-foto]', conj);
      function sincronizar() {
        var dos = dosMascotas(form);
        var inp2 = $('input[type=file]', segunda);
        segunda.hidden = !dos;
        inp2.disabled = !dos;
        inp2.required = dos;
        if (!dos) {
          inp2.value = '';
          $('.gt-foto__listo', segunda).hidden = true;
          $('.gt-foto__zona', segunda).hidden = false;
        }
        $('[data-gt-foto-titulo]', primera).textContent = dos ? 'Foto de la mascota 1' : 'Sube la foto de tu mascota';
      }
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[data-gt-opcion]')) sincronizar();
      });
      sincronizar();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
